import { Component, Input, OnInit } from '@angular/core';
import { BalanceSection } from 'src/app/models/reporte-financiero/reporte-financiero.model'

@Component({
  selector: 'app-balance-detalle',
  templateUrl: './balance-detalle.component.html',
  styleUrls: ['./balance-detalle.component.scss']
})
export class BalanceDetalleComponent {
  @Input() elementos: any[] = [];
  @Input() data: BalanceSection | any = null;

  public showData: boolean = false;

  constructor() { }

  ngOnInit(): void {
    if(this.elementos && this.elementos.length > 0) {
      this.showData = true;
    }
  }

  validateFecha(classHTML: string): boolean {
    if(!classHTML) return false;
    if(classHTML.includes('span-fecha')) return true;
    return false;
  }

}
